import { IntentType } from '@40seas/entities/intents';

export const tokenPrefixMap: Record<IntentType, string> = {
    [IntentType.Checkout]: 'ch',
    [IntentType.Invoice]: 'in',
    [IntentType.AddContact]: 'ac',
    [IntentType.PaymentMethod]: 'pm',
    [IntentType.WithdrawWalletBalance]: 'ww',
    [IntentType.ConvertWalletBalance]: 'cw',
    [IntentType.Order]: 'or',
    [IntentType.UploadLogo]: 'ul',
    [IntentType.Onboard]: 'ob',
    [IntentType.CreditLine]: 'cl',
    [IntentType.SupplierAgreement]: 'sa',
    [IntentType.PaymentProcessingAgreement]: 'pp',
    [IntentType.SupplierDocuments]: 'sd',
    [IntentType.BuyerSignup]: 'su',
    [IntentType.BuyerInvoice]: 'bi',
    [IntentType.Signup]: 'sg',
    [IntentType.SignupInvite]: 'si',
    [IntentType.CreateBuyer]: 'cb',
    [IntentType.FinancialConnection]: 'fc',
    [IntentType.FinancialConnectionReconnect]: 'fr',
    [IntentType.Organization]: 'og',
    [IntentType.PaymentLink]: 'pl',
    [IntentType.SupplierBankAccount]: 'sb',
    [IntentType.SupplierSignatory]: 'ss',
    [IntentType.BuyerGuarantee]: 'bg',
    [IntentType.BuyerSignatory]: 'bs',
    [IntentType.Signatory]: 'sg',
    [IntentType.BuyerOwner]: 'bo',
    [IntentType.SupplierDataConnection]: 'sd',
    [IntentType.InvoiceSearch]: 'is',
    [IntentType.CurrencyExchange]: 'ce',
    [IntentType.WithdrawalBalance]: 'wb',
    [IntentType.VerifyIdentity]: 'vi',
    [IntentType.SupplierOnboard]: 'so',
    [IntentType.RequestCover]: 'rc',
    [IntentType.CompanySearch]: 'cs',
    [IntentType.CreditReference]: 'cr',
    [IntentType.GuestBuyerLink]: 'gb',
    [IntentType.InsuranceApplication]: 'ia',
    [IntentType.ManualInsuranceCover]: 'mi',
    [IntentType.GuestCreditLineLink]: 'gc',
    [IntentType.LandingPageGuest]: 'lg',
    [IntentType.UploadProofOfPayment]: 'up',
} as const;
